import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EnderecoPipe } from "src/app/pipes/endereco/endereco";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, IonicModule } from "@ionic/angular";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { FieldConfig } from "src/app/interfaces/field.interface";
import { CommonModule } from "@angular/common";
import { DynamicFieldDirective } from "../../directive/dynamic-field/dynamic-field.directive";

@Component({
  exportAs: "dynamicForm",
  selector: "dynamic-form",
  template: `
    <ion-card>
      <form class="dynamic-form" [formGroup]="formGroup" (submit)="onSubmit($event)">
        <ng-container *ngFor="let field of fields" dynamicField [field]="field" [group]="formGroup" [isSubmitting]="isSubmitting"> </ng-container>
      </form>
    </ion-card>
  `,
  styles: [
    `
      ion-card {
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4) !important;
        --color:inherit;
      }
    `,
  ],
  standalone: true,
  imports: [IonicModule, CommonModule, ReactiveFormsModule, FormsModule, DynamicFieldDirective],
})
export class DynamicFormComponent implements OnChanges {
  @Input() fields: FieldConfig[];
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  isSubmitting = false;
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    public pessoaProvider: PessoaProvider,
    public alertCtrl: AlertController
  ) { }

  get value() {
    return this.formGroup.value;
  }

  createControlFromFields(fields: FieldConfig[]) {
    this.fields = fields;
    this.formGroup = this.createControl();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["fields"] && changes["fields"].currentValue) {
      this.formGroup = this.createControl();
    }
  }


  onSubmitExterno() {
    if (!this.formGroup.valid) {
      return false;
    }

    this.submit.emit(this.formGroup.value);
    return true;
  }

  async onSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.formGroup.valid) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.submit.emit(this.formGroup.getRawValue());

    } else {
      this.finishSubmit();
      this.validateAllFormFields(this.formGroup);
      const alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant("Atenção"),
        message: this.translate.instant("Verifique se todos os campos foram preenchidos corretamente."),
        buttons: [
          {
            text: this.translate.instant("Ok"),
            role: "cancel",
          },
        ],
      });
      await alert.present();
    }
  }

  finishSubmit() {
    this.isSubmitting = false;
  }

  createControl() {
    this.formGroup = this.formBuilder.group({
      titulo: new FormControl("", Validators.required),
      descricao: new FormControl("", Validators.nullValidator),
    });

    const group = this.formBuilder.group({});

    this.fields.forEach((field) => {
      if (field.type === "button" || field.type === "divider" || field.type === "termo") {
        return;
      }

      if (field.type === "inputmask" && field.mask) {
        if (field.value && field.mask.type == "phone") {
          // field.value = this.createPhone(field.value);
          field.value = field.value;
        } else if (field.value && field.mask.type == "custom") {
          // field.value = this.createCustom(field.value, field.mask.custom);
          (field.value = field.value), field.mask.custom;
        }
      }

      let value = field.value;
      if (field.type == "endereco") {
        const enderecoPipe = new EnderecoPipe();
        const endereco = enderecoPipe.transform(field.value);
        value = field.value.logradouro ? endereco : "";
      }

      const control = this.formBuilder.control(value, this.bindValidations(field.validations || []));

      group.addControl(field.name, control);
      const ddiKey = Object.keys(field).find((k) => k.startsWith("ddiTel"));
      if (ddiKey) {
        group.addControl(ddiKey, this.formBuilder.control(field[ddiKey] || ""));
      }
    });

    return group;
  }

  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList: any[] = [];
      validations.forEach((valid: any) => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control!.markAsTouched({ onlySelf: true });
      control?.markAsDirty();
    });
  }
}
